
{
  "familyId": "GET-BREUK-BASIS",
  "questions": [
    {
      "id": "GET-BREUK-BASIS-001",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "multiple_choice",
      "question": "Welke breuk zie je hier? (3 van de 4 delen zijn gekleurd)",
      "context": null,
      "options": ["$\\frac{3}{4}$", "$\\frac{1}{4}$", "$\\frac{4}{3}$", "$\\frac{3}{1}$"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "label": "3 van de 4 delen",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuk aflezen van een plaatje",
            "content": "Tel het totaal aantal gelijke stukken → dat is de noemer (onder de streep). Tel de gekleurde stukken → dat is de teller (boven de streep). Hier: 4 stukken totaal, 3 gekleurd = ¾.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fraction_visual_read_bar",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Je ziet 4 gelijke stukken. Daarvan zijn er 3 gekleurd. Het getal boven de streep (teller) zegt hoeveel stukken gekleurd zijn: 3. Het getal onder de streep (noemer) zegt hoeveel stukken er totaal zijn: 4. Dus: $\\frac{3}{4}$.",
        "solutionSteps": [
          "Tel het totaal aantal stukken: 4 → noemer",
          "Tel de gekleurde stukken: 3 → teller",
          "Schrijf de breuk: $\\frac{3}{4}$ ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 3 van de 4 stukken zijn gekleurd: $\\frac{3}{4}$.",
          "1": "Bij $\\frac{1}{4}$ zou maar 1 stuk gekleurd zijn. Tel opnieuw: er zijn 3 stukken gekleurd.",
          "2": "Bij $\\frac{4}{3}$ staat het totaal boven de streep. Maar de teller (boven) telt de gekleurde stukken, de noemer (onder) het totaal.",
          "3": "$\\frac{3}{1}$ betekent 3 hele. Dat past niet bij het plaatje — je hebt minder dan 1 heel."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "get.fraction-count-error", "label": "Verkeerd aantal geteld", "optionIndex": 1 },
          { "id": "get.fraction-teller-noemer-swap", "label": "Teller en noemer verwisseld", "optionIndex": 2 },
          { "id": "get.fraction-whole-confusion", "label": "Breuk als geheel getal gelezen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "GET-BREUK-BASIS-002",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "grid_shade",
      "question": "Kleur $\\frac{3}{8}$ van het rooster in.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "gridShade": {
          "gridRows": 2,
          "gridCols": 4,
          "targetCount": 3,
          "mode": "shade_fraction",
          "showCounter": true
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 8,
            "label": "3 van de 8 vakjes",
            "visualType": "bar",
            "showEaten": false
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuk inkleuren",
            "content": "De noemer (8) zegt hoeveel vakjes er totaal zijn. De teller (3) zegt hoeveel je moet inkleuren. Tel 8 vakjes in het rooster en kleur er 3 in.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fraction_shade_grid",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Het rooster heeft 2 × 4 = 8 vakjes. De breuk $\\frac{3}{8}$ zegt: kleur 3 van de 8 vakjes in. De noemer vertelt het totaal, de teller hoeveel je inkleurt.",
        "solutionSteps": [
          "Tel het totaal aantal vakjes: 2 × 4 = 8",
          "De teller is 3 → kleur 3 vakjes in",
          "Check: 3 van de 8 vakjes = $\\frac{3}{8}$ ✓"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "hasStructuredData": true
      }
    },
    {
      "id": "GET-BREUK-BASIS-003",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "multiple_choice",
      "question": "Welke breuk hoort bij dit plaatje? (2 van de 5 taartpunten zijn op)",
      "context": null,
      "options": ["$\\frac{2}{5}$", "$\\frac{3}{5}$", "$\\frac{5}{2}$", "$\\frac{2}{3}$"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 2,
            "denominator": 5,
            "label": "2 van de 5 punten",
            "visualType": "circle",
            "showEaten": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuk aflezen van een cirkel",
            "content": "Tel het totaal aantal gelijke stukken → noemer. Tel de gekleurde (of opgegeten) stukken → teller. Hier: 5 stukken totaal, 2 op = ²⁄₅.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fraction_visual_read_circle",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De taart is verdeeld in 5 gelijke stukken. Daarvan zijn er 2 op (gekleurd). Teller = 2, noemer = 5. De breuk is $\\frac{2}{5}$.",
        "solutionSteps": [
          "Tel het totaal aantal stukken: 5 → noemer",
          "Tel de opgegeten stukken: 2 → teller",
          "Schrijf de breuk: $\\frac{2}{5}$ ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 2 van de 5 stukken zijn op: $\\frac{2}{5}$.",
          "1": "$\\frac{3}{5}$ zou kloppen als je de overgebleven stukken telt. Maar de vraag gaat over de opgegeten stukken: 2.",
          "2": "Bij $\\frac{5}{2}$ staan teller en noemer omgedraaid. De noemer (totaal) hoort onder de streep.",
          "3": "$\\frac{2}{3}$ klopt niet — er zijn 5 stukken totaal, niet 3."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "get.fraction-remaining-vs-eaten", "label": "Overgebleven i.p.v. opgegeten geteld", "optionIndex": 1 },
          { "id": "get.fraction-teller-noemer-swap", "label": "Teller en noemer verwisseld", "optionIndex": 2 },
          { "id": "get.fraction-wrong-total", "label": "Verkeerd totaal geteld", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "GET-BREUK-BASIS-004",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "multiple_choice",
      "question": "Welk plaatje hoort bij de breuk $\\frac{1}{3}$?",
      "context": null,
      "options": [
        "Een reep in 3 stukken, 1 gekleurd",
        "Een reep in 3 stukken, 2 gekleurd",
        "Een reep in 4 stukken, 1 gekleurd",
        "Een reep in 2 stukken, 1 gekleurd"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 3,
            "label": "A: 1 van 3",
            "visualType": "bar",
            "showEaten": false
          }
        },
        {
          "type": "fraction",
          "data": {
            "numerator": 2,
            "denominator": 3,
            "label": "B: 2 van 3",
            "visualType": "bar",
            "showEaten": false
          }
        },
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 4,
            "label": "C: 1 van 4",
            "visualType": "bar",
            "showEaten": false
          }
        },
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 2,
            "label": "D: 1 van 2",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van breuk naar plaatje",
            "content": "Lees de breuk: $\\frac{1}{3}$ betekent 1 deel van 3 gelijke stukken. Zoek het plaatje met 3 stukken waarvan er 1 gekleurd is.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fraction_visual_match",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "$\\frac{1}{3}$ betekent: verdeel in 3 gelijke stukken en kleur er 1. Plaatje A toont precies dat: een reep in 3 stukken met 1 gekleurd.",
        "solutionSteps": [
          "Lees de noemer: 3 → zoek een plaatje met 3 stukken",
          "Lees de teller: 1 → er moet 1 stuk gekleurd zijn",
          "Plaatje A: 3 stukken, 1 gekleurd = $\\frac{1}{3}$ ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 3 stukken, 1 gekleurd = $\\frac{1}{3}$.",
          "1": "Dit plaatje toont $\\frac{2}{3}$: er zijn 2 stukken gekleurd in plaats van 1.",
          "2": "Dit plaatje heeft 4 stukken (noemer 4), maar $\\frac{1}{3}$ heeft noemer 3.",
          "3": "Dit plaatje toont $\\frac{1}{2}$: er zijn maar 2 stukken, niet 3."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "get.fraction-count-error", "label": "Verkeerd aantal gekleurde stukken", "optionIndex": 1 },
          { "id": "get.fraction-wrong-total", "label": "Verkeerd totaal (noemer)", "optionIndex": 2 },
          { "id": "get.fraction-wrong-total", "label": "Verkeerd totaal (noemer)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "GET-BREUK-BASIS-005",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "grid_shade",
      "question": "Kleur $\\frac{5}{6}$ van het rooster in.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "gridShade": {
          "gridRows": 2,
          "gridCols": 3,
          "targetCount": 5,
          "mode": "shade_fraction",
          "showCounter": true
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 5,
            "denominator": 6,
            "label": "5 van de 6 vakjes",
            "visualType": "bar",
            "showEaten": false
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuk inkleuren — bijna alles!",
            "content": "De noemer (6) zegt hoeveel vakjes er totaal zijn. De teller (5) zegt hoeveel je moet inkleuren. Bijna alles! Alleen 1 vakje blijft leeg.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fraction_shade_grid_large_teller",
      "variantIndex": 1,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het rooster heeft 2 × 3 = 6 vakjes. De breuk $\\frac{5}{6}$ zegt: kleur 5 van de 6 vakjes in. Er blijft maar 1 vakje leeg.",
        "solutionSteps": [
          "Tel het totaal aantal vakjes: 2 × 3 = 6",
          "De teller is 5 → kleur 5 vakjes in",
          "Check: 5 van de 6 vakjes = $\\frac{5}{6}$ ✓"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "hasStructuredData": true
      }
    },
    {
      "id": "GET-BREUK-BASIS-006",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "multiple_choice",
      "question": "Een chocoladereep is verdeeld in 8 gelijke stukken. Jij eet er 3 op. Welke breuk heb je opgegeten?",
      "context": null,
      "options": ["$\\frac{3}{8}$", "$\\frac{5}{8}$", "$\\frac{8}{3}$", "$\\frac{3}{5}$"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 3,
            "denominator": 8,
            "label": "3 van de 8 stukken opgegeten",
            "visualType": "bar",
            "showEaten": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuk bij een verhaaltje",
            "content": "De reep heeft 8 stukken (noemer = 8). Je eet er 3 op (teller = 3). De breuk is $\\frac{3}{8}$. Let op: de vraag gaat over wat je hebt opgegeten, niet wat er over is!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fraction_visual_context",
      "variantIndex": 1,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De reep heeft 8 gelijke stukken. Je eet er 3 op. Teller = 3 (opgegeten), noemer = 8 (totaal). De breuk is $\\frac{3}{8}$.",
        "solutionSteps": [
          "Totaal aantal stukken: 8 → noemer",
          "Opgegeten stukken: 3 → teller",
          "Breuk: $\\frac{3}{8}$ ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 3 opgegeten van 8 totaal = $\\frac{3}{8}$.",
          "1": "$\\frac{5}{8}$ is het deel dat over is (8 − 3 = 5). De vraag gaat over wat je hebt opgegeten.",
          "2": "Bij $\\frac{8}{3}$ staan teller en noemer omgedraaid. Het totaal (8) hoort onder de streep.",
          "3": "$\\frac{3}{5}$ klopt niet — er zijn 8 stukken totaal, niet 5. De 5 is het aantal dat over is."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "get.fraction-remaining-vs-eaten", "label": "Rest i.p.v. opgegeten deel", "optionIndex": 1 },
          { "id": "get.fraction-teller-noemer-swap", "label": "Teller en noemer verwisseld", "optionIndex": 2 },
          { "id": "get.fraction-wrong-total", "label": "Rest als noemer gebruikt", "optionIndex": 3 }
        ]
      }
    }
  ]
}
